import { LoadableBackground } from '@confluence/loadable';

export const CommentWarningDialog = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CommentWarningDialog" */ './CommentWarningDialog.tsx'
			)
		).CommentWarningDialog,
});
